// La espera pertenece a cada instancia; escribir sigue actualizando el modelo al instante.
const SEARCH_DELAY = 300;

export default {
  data() {
    return {
      searchTimer: null,
      pendingSearchText: null,
    };
  },
  mounted() {
    this.$el.addEventListener("hidden.bs.dropdown", this.onSearchDropdownHidden);
    this.$el.addEventListener("shown.bs.dropdown", this.onSearchDropdownShown);
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    this.cancelPendingSearch();
    if (this.$el) {
      this.$el.removeEventListener("hidden.bs.dropdown", this.onSearchDropdownHidden);
      this.$el.removeEventListener("shown.bs.dropdown", this.onSearchDropdownShown);
    }
  },
  methods: {
    scheduleSearch(text) {
      this.cancelPendingSearch();
      this.page = 0;
      this.pendingSearchText = text;
      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;
        this.pendingSearchText = null;
        this.$emit("load", 0, text, "textChanged");
      }, SEARCH_DELAY);
    },
    cancelPendingSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
      this.pendingSearchText = null;
    },
    onSearchDropdownHidden(event) {
      if (event.target !== this.$el.querySelector(".dropdown-toggle")) return;
      // Pausar una búsqueda todavía no enviada; se retoma al reabrir el menú.
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    },
    onSearchDropdownShown(event) {
      if (event.target !== this.$el.querySelector(".dropdown-toggle")) return;
      if (this.searchTimer === null && this.pendingSearchText !== null) {
        this.scheduleSearch(this.pendingSearchText);
      }
    },
  },
};
